var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLemonPepper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / Flavor / LemonPepper") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "lemonP-path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "lemonP-path-3",
    points: "13.4289404 17.4092522 19.3628777 17.3229244 13.0561946 26.0588565 18.0986879 25.7358589 12.13 35 25.4398411 21.6246815 20.2363978 22.3595649 27.8698217 12.9534952 21.666293 14.1375758 27.1331093 5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lemonP-icon-/-Flavor-/-LemonPepper",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "lemonP-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "lemonP-New"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "lemonP-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "lemonP-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lemonP-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lemonP-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "lemonP-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#lemonP-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lemonP-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#lemonP-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "lemonP-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lemonP-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "lemonP-Fill-1",
    fill: "#231F20",
    xlinkHref: "#lemonP-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lemonP-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#lemonP-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonPepper);
export default __webpack_public_path__ + "static/media/LemonPepper.a253aa2eb872c6548793ebb12c52f2f1.svg";
export { ForwardRef as ReactComponent };